import { NgModule } from '@angular/core';
import { S145gS145m01Component } from './s145g-s145m01.component';
import { S145gS145m02Component } from './s145g-s145m02.component';
import { SharedModule } from './../../shared.module';

@NgModule({
    imports: [SharedModule],
    exports: [],
    declarations: [S145gS145m01Component,
		S145gS145m02Component]
})
export class S145gModule { }

